/**
 * Get the URL to Spordle Account platform
 * @param {string} [authAs='SPORDLE'] Where we went to connect.
 * @return {string} The url to Spordle Account platform
 */
export default function getAccountUrl(authAs = 'CLINIC', auth = true){
    const endPath = getEndPath(authAs, auth);

    switch (process.env.REACT_APP_ENVIRONMENT){
        case 'prod':
            return `https://myaccount.spordle.com/${endPath}`;
        case 'training':
            return `https://account.training.hcr.spordle.com/${endPath}`;
        case 'uat':
            return `https://account.stage.spordle.dev/${endPath}`;
        case 'hcstage':
            return `https://account.stage.spordle.dev/${endPath}`;
        case 'stage':
            return `https://account.stage.spordle.dev/${endPath}`;
        case 'int':
            return `https://account.dev.spordle.dev/${endPath}`;
        case 'dev':
        default:
            return `https://account.dev.spordle.dev/${endPath}`;

    }
}

function getEndPath(authAs = 'CLINIC', auth = true){
    let client_code = '';
    switch (process.env.REACT_APP_ENVIRONMENT){
        case 'dev':
        case 'int':
            client_code = 'hcr';
            break;
        default:
            client_code = 'hockey-canada';
            break;

    }

    return auth ? `auth/${authAs}?c=${client_code}` : `login?c=${client_code}`;
}